import config from '../config';

export default 
{
	// App values
	appInitialState : 
	{
		isOpen: [], //for active default menu
		isTrigger: [], //for active default menu, set blank for horizontal
		...config,
		isFullScreen: false, // static can't change
	},

	appCommonReducerVal: {
		screenContext: []
	},

	// Login
	changePasswordData: {},
	changePasswordErrorFlag: false,
	changePasswordLoading: false,

	forgotPasswordData: {},
	forgotPasswordErrorFlag: false,
	forgotPasswordLoading: false,

	loginData: {},
	loginErrorFlag: false,
	loginLoading: false,
	loginSuccessFlag: false,

	updateUserLicenseAgreementStatusErrorFlag: false,
	updateUserLicenseAgreementStatusLoading: false,

	// Asset
	addSuperAssetCommentErrorFlag: false,
	addSuperAssetCommentLoading: false,
	addAssetCommentErrorFlag: false,
	addAssetCommentLoading: false,

	assetComments: [],
	assetCommentsErrorFlag: false,
	assetCommentsLoading: false,

	assetCount:
		{
		calibratingAssetCount: 0,
		checkupAssetCount: 0,
		healthyAssetCount: 0,
		unknownAssetCount: 0,
		urgentAssetCount: 0,
	},
	assetCountDataLoading: false,
	assetCountErrorFlag: false,

	assetGraphCurrentData: {},
	assetGraphHistoricalData: {},
	assetGraphDataLoading: false,
	assetGraphErrorFlag: false,

	assetDetails: {},
	assetDetailsErrorFlag: false,
	assetDetailsLoading: false,

	assetDownloadMeasurementDataLoading: false,
	assetDownloadMeasurementDataErrorFlag: false,
		
	assetConditionInfo: [],
	assetConditionInfoErrorFlag: false,
	assetConditionInfoLoading: false,

	assetOutputData: {},
	assetOutputErrorFlag: false,
	assetOutputDataLoading: false,

	centerDateTimeList: [],
	centerDateTimeOutputErrorFlag: false,
	centerDateTimeOutputDataLoading: false,

	exportSensorListErrorFlag: false,
	exportSensorListLoading: false,

	faultEnumList: [],
	faultEnumListErrorFlag: false,
	faultEnumListLoading: false,

	metricList: [],
	metricListErrorFlag: false,
	metricListLoading: false,

	plotlyGraphAndTableJson: {},
	plotlyGraphAndTableJsonOutputErrorFlag: false,
	plotlyGraphAndTableJsonOutputLoading: false,

	quickFeedbackData: {},
	quickFeedbackErrorFlag: false,
	quickFeedbackLoading: false,

	superAssetComments: [],
	superAssetCommentsErrorFlag: false,
	superAssetCommentsLoading: false,

	superAssetDetails: {},
	superAssetDetailsErrorFlag: false,
	superAssetDetailsLoading: false,

	moteState: "",
	updateMoteStateErrorFlag: false,
	updateMoteStateLoading: false,

	updateCustAssetTagErrorFlag: false,
	updateCustAssetTagLoading: false,

	updateAlternateIdErrorFlag: false,
	updateAlternateIdLoading: false,

	// Sensor

	sensorHistory: [],
	sensorHistoryErrorFlag: false,
	sensorHistoryLoading: false,
	
	replaceSensorErrorFlag: false,
	replaceSensorLoading: false,

	addSensorLoading: false,
	addSensorErrorFlag: false,

	sensorOutputData: {},
	sensorOutputErrorFlag: false,
	sensorOutputDataLoading: false,

	updateSensorUnresponsiveReasonErrorFlg: false,
	updateSensorUnresponsiveReasonLoading: false,

	sensorUnresponsiveReasonListErrorFlag: false,
	sensorUnresponsiveReasonListLoading: false,
	sensorUnresponsiveReasonList: [],

	unattachedSensorListErrorFlag: false,
	unattachedSensorListLoading: false,
	unattachedSensorList: [],

	updateSensorInfoErrorFlag: false,
	updateSensorInfoLoading: false,

	detachSensorLoading: false,
	detachSensorErrorFlg: false,

	getProgramIdList: [],
	getProgramIdLoading: false,
	getProgramIdErrorFlag: false,

  	// Customer
	customerOutputData: {},
	customerOutputErrorFlag: false,
	customerOutputDataLoading: false,

	// Feed
	addFeedCommentErrorFlag: false,
	addFeedCommentLoading: false,
	addedUserFeedStatus: false,
	addUserFeedErrorFlag: false,
	addUserFeedLoading: false,
	assetFeedOutputData: {},
	feedComments: [],
	feedCommentErrorFlag: false,
	feedCommentLoading: false,
	feedFollowOrUnfollowErrorFlag: false,
	feedFollowUnFollowLoading: false,
	feedOutputData: {},
	feedOutputErrorFlag: false,
	feedOutputDataLoading: false,
	newFeedOutputData: {},
	feedbackFiles: [],
	feedbackFilesLoading: false,
	feedbackFilesError: false,

	refreshFeedOutputErrorFlag: false,
	refreshFeedOutputDataLoading: false,

	feedsLastUpdatedDateTime: 
	{
		userFeedsLastUpdatedDateTime: 0,
		assetFeedsLastUpdatedDateTime: 0,
		ticketFeedsLastUpdatedDateTime: 0
	},

	newFeedsCount: 
	{
		countOfAssetFeeds: 0,
		countOfTicketFeeds: 0,
		countOfUserFeeds: 0
	},

	updateNewFeedsIntoOldFeedsLoading: false,
	lastSelectedCustomerId: null,

	//Ticket,
	addTicketCommentErrorFlag:false,
	addTicketCommentLoading: false,
	ticketFeedback: {},
	addTicketFeedbackErrorFlag: false,
	addTicketFeedbackLoading: false,
	assignUserToTicketErrorFlag: false,
	assignUserToTicketLoading: false,
	ticketCreatedStatus: false,
	createTicketErrorFlag: false,
	createTicketLoading: false,
	feedbackHistory: [],
	feedbackHistoryErrorFlag: false,
	feedbackHistoryLoading: false,
	ticketCloseOrReopenData: {},
	ticketCloseOrReopenErrorFlag: false,
	ticketCloseOrReopenLoading: false,
	ticketDetails: {},
	ticketDetailsErrorFlag: false,
	ticketDetailsLoading: false,

	// User
	userDetails: {},
	userDetailsErrorFlag: false,
	userDetailsLoading: false,
	userOutputData: {},
	userOutputErrorFlag: false,
	userOutputDataLoading: false,

	superAssetImagesErrorFlag: false,
	superAssetImagesLoading: false,
	superAssetImages: {
		images: {},
		errorMessage: ""
	},

	assetImagesErrorFlag: false,
	assetImagesLoading: false,
	assetImages: {},

	saveImageRotationsAngleErrorFlag: false,
	saveImageRotationsAngleLoading: false,

	deleteAssetImageErrorFlag: false,
	deleteAssetImageLoading: false,

	deleteSuperAssetImageErrorFlag: false,
	deleteSuperAssetImageLoading: false,

	fetchFeedbackTags: [],
	fetchFeedbackTagsLoading: false,
	fetchFeedbackTagsErrorFlag: false,
	downloadFeedbackFilesLoading: false,
	downloadFeedbackFilesErrorFlag: false,


	feedbackAssetDetailsErrorFlag: false,
	feedbackAssetDetailsLoadingFlag: false,
	feedbackAssetDetails: {},

	feedbackTokenVerificationLoading: false,
	feedbackTokenVerificationErrorFlag: false,
	feedbackTokenVerificationSuccess: false,

	// Oil Report
	oilTestReportFiles: [],
	oilTestReportFilesErrorFlag: false,
	oilTestReportFilesLoading: false,
	uploadOilTestReportData: {},
	uploadOilTestReportErrorFlag: false,
	uploadOilTestReportLoading: false,
}
